import { getQuery, execQuery, postToServer, luaScript, getVers } from '../../helpers/helper_store';

const state = {
	basesTableArray: [],
	sectionsTableArray: [],
	sectionPackets: [],
	serversTableArray: [],
	serversVersions: {
		main: null,
		front: null,
		tiny: []
	},
	usersTableArray: [],
	appParamTableArray: [],
	sectionsInBase: [],
	rolesTableArray: [],
	upgradesTable: [],
	hardwareInfo: []
};

const mutations = {
	setBasesTableArray: (state, data) => (state.basesTableArray = Array.isArray(data) ? data : [data]),
	setSectionsTableArray: (state, data) => (state.sectionsTableArray = Array.isArray(data) ? data : [data]),
	setSectionPackets: (state, data) => (state.sectionPackets = Array.isArray(data) ? data : [data]),
	setServersTableArray: (state, data) => (state.serversTableArray = Array.isArray(data) ? data : [data]),
	setServersVersions: (state, data) => {
		state.serversVersions.main = data.main;
		state.serversVersions.front = data.front;
		state.serversVersions.tiny = data.tiny
	},
	setUsersTableArray: (state, data) => (state.usersTableArray = Array.isArray(data) ? data : [data]),
	setAppParamTableArray: (state, data) => (state.appParamTableArray = Array.isArray(data) ? data : [data]),
	setSectionsInBase: (state, data) => (state.sectionsInBase = Array.isArray(data) ? data : [data]),
	setRolesTableArray: (state, data) => (state.rolesTableArray = Array.isArray(data) ? data : [data]),
	setUpgradesTable: (state, data) => (state.upgradesTable = Array.isArray(data) ? data : [data]),
	setHardwareInfo: (state, data) => {
		state.hardwareInfo = [];
		for (const server of data) {
			const result = {};
			result.server = server.server; //{name, id}
			if (!server.hardware && server.error) {
				result.error = server.error;
				state.hardwareInfo.push(result);
				continue;
			}
			for (const command in server.hardware) {
				result[command] = {};
				result[command].caption = server.hardware[command].caption;
				result[command].head = [...server.hardware[command].head];
				result[command].head.pop(); //removing color 
				result[command].data = [];
				for (const element of server.hardware[command].body) {
					const row = {};
					for (let index = 0; index < element.length; index++) {
						row[server.hardware[command].head[index]] = element[index];
					}
					result[command].data.push(row);
				}
			}
			state.hardwareInfo.push(result);
		}
	}
};

const actions = {
	getBaseTable({ rootState, commit }) {
		return new Promise((resolve, reject) => {
			getQuery('getBaseTable', null, rootState.login)
				.then((result) => {
					commit('setBasesTableArray', result);
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	},
	getSectionTable({ rootState, commit }) {
		return new Promise((resolve, reject) => {
			getQuery('getSectionTable', null, rootState.login)
				.then((result) => {
					commit('setSectionsTableArray', result);
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	},
	getSectionPackets({ rootState, commit }, idSection) {
		return new Promise((resolve, reject) => {
			getQuery("getCronPacketsBySection", [idSection], rootState.login)
				.then((result) => {
					commit("setSectionPackets", result);
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	},
	getServerTable({ rootState, commit }) {
		return new Promise((resolve, reject) => {
			getQuery('getServerTable', null, rootState.login)
				.then((result) => {
					commit('setServersTableArray', result);
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	},
	getServersVersions({ rootState, commit }) {
		return new Promise((resolve, reject) => {
			luaScript("agentVers", "getVers", null, rootState.login).then((result) => {
				commit('setServersVersions', result);
				return getVers(rootState.login.base.url);
			}).then((result) => {
				commit("setMainVers", result);
				resolve();
			})
				.catch((e) => {
					console.error(e);
					reject();
				})
		})
	},
	getUserTable({ rootState, commit }) {
		return new Promise((resolve, reject) => {
			let query = 'getUserList_all';
			//console.log(rootState);
			if (rootState.login.user.roleid !== '0') {
				query = 'getUserList';
			}
			getQuery(query, null, rootState.login)
				.then((result) => {
					commit('setUsersTableArray', result);
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	},
	getRoleTable({ rootState, commit }) {
		return new Promise((resolve, reject) => {
			let query = 'getRoleList_all';
			//console.log(rootState);
			if (rootState.login.user.roleid !== '0') {
				query = 'getRolesForAdmin';
			}
			getQuery(query, null, rootState.login)
				.then((result) => {
					commit('setRolesTableArray', result);
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	},
	getAppParamTable({ rootState, commit }) {
		return new Promise((resolve, reject) => {
			getQuery('getSectionParamType', null, rootState.login)
				.then((result) => {
					commit('setAppParamTableArray', result);
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	},
	getUpgradesTable({ rootState, commit }) {
		return new Promise((resolve, reject) => {
			getQuery('getUpgTable', null, rootState.login)
				.then((result) => {
					commit('setUpgradesTable', result);
					resolve();
				})
				.catch((err) => {
					reject(err);
				})
		})
	},
	getHardwareInfo({ rootState, commit }) {
		return new Promise((resolve, reject) => {
			luaScript("HWinfo", "getInfo", null, rootState.login).then((result) => {
				commit("setHardwareInfo", result);
				resolve();
			}).catch((err) => {
				reject(err);
			})
		})
	},
	getSectionsInBase({ rootState, commit }, idBase) {
		return new Promise((resolve, reject) => {
			getQuery('getSectionInBase', [idBase], rootState.login)
				.then((result) => {
					commit('setSectionsInBase', result);
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	},
	unlinkBaseInReference({ rootState, dispatch }, { idSection, idBase }) {
		let sectionArray = Array.isArray(idSection) ? idSection : [idSection];
		return new Promise((resolve, reject) => {
			execQuery('delBaseSectionLinksByBaseListSection', [idBase, ...sectionArray], rootState.login)
				.then(() => {
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	},
	delBaseTable({ rootState }, idBase) {
		return new Promise((resolve, reject) => {
			luaScript('newDBeraser', 'run', { idBase, action: 'erase' }, rootState.login)
				.then(() => {
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	},
	unlinkSectionInReference({ rootState }, { idSection, idBase }) {
		let baseArray = Array.isArray(idBase) ? idBase : [idBase];
		return new Promise((resolve, reject) => {
			execQuery('delBaseSectionLinksBySectionListBase', [idSection, ...baseArray], rootState.login)
				.then(() => {
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	},
	deleteUser({ rootState }, idUser) {
		return new Promise((resolve, reject) => {
			execQuery('delUser', [idUser], rootState.login)
				.then(() => {
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	},
	deleteAppParam({ rootState }, idParam) {
		return new Promise((resolve, reject) => {
			execQuery('delParamTable', [idParam], rootState.login)
				.then(() => {
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	},
	deleteRole({ rootState }, idRole) {
		return new Promise((resolve, reject) => {
			execQuery('delRoleTable', [idRole], rootState.login)
				.then(() => {
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	},
	createBase({ rootState }, data) {
		return new Promise((resolve, reject) => {
			execQuery(
				'insBaseTable',
				[
					data.nameSelected,
					data.shortNameSelected,
					data.aliasSelected,
					data.commentSelected,
					data.baseSelected,
					data.serverSelected
				],
				rootState.login
			)
				.then(() => {
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	},
	createSection({ rootState }, data) {
		return new Promise((resolve, reject) => {
			execQuery(
				'insSectionTable',
				[
					data.nameSelected,
					data.aliasSelected,
					data.pathSelected,
					data.serverSelected,
					data.apiSelected,
					data.webAppSelected
				],
				rootState.login
			)
				.then(() => {
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	},
	createServer({ rootState }, data) {
		return new Promise((resolve, reject) => {
			execQuery(
				'insServerTable',
				[
					data.nameSelected,
					data.serverTypeSelected,
					data.urlSelected,
					data.hostSelected,
					data.pathSelected,
					data.tinySelected
				],
				rootState.login
			)
				.then(() => {
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	},
	createUser({ rootState }, data) {
		const object = {
			cmd: 'addUser',
			login: data.loginSelected,
			passwd: data.password,
			idRole: parseInt(data.idRole),
			fullName: data.fullNameSelected
		};
		return new Promise((resolve, reject) => {
			postToServer(object, rootState.login)
				.then(() => {
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	},
	changeUserRole({ rootState }, { userid, roleid }) {
		return new Promise((resolve, reject) => {
			luaScript('roledit', 'bindRole', { userid, roleid }, rootState.login).then(() => {
				resolve();
			}).catch(() => {
				reject();
			})
		})
	},
	createAppParam({ rootState }, data) {
		//console.log(data);
		return new Promise((resolve, reject) => {
			execQuery('insParamTable', [data.nameSelected, data.nameSelected], rootState.login)
				.then(() => {
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	},
	createRole({ rootState }, data) {
		return new Promise((resolve, reject) => {
			execQuery('insRoleTable', [data.nameSelected, data.specialUserChecked], rootState.login)
				.then(() => {
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	}
};

const getters = {
	getBasesTableArray: (state) => state.basesTableArray,
	getSectionsTableArray: (state) => state.sectionsTableArray,
	sectionPackets: (state) => state.sectionPackets,
	getServersTableArray: (state) => state.serversTableArray,
	serversVersions: (state) => state.serversVersions,
	getUsersTableArray: (state) => state.usersTableArray,
	getAppParamTableArray: (state) => state.appParamTableArray,
	getSectionsInBaseArray: (state) => state.sectionsInBase,
	getRolesTableArray: (state) => state.rolesTableArray,
	getUpgradesTable: (state) => state.upgradesTable,
	getHardwareInfo: (state) => state.hardwareInfo
};

export default {
	state,
	mutations,
	actions,
	getters
};
